export { getLayout } from './MainLayout';
